import styled from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

export const Container = styled.div`
  border: 1px solid ${theme.colors.primary.transparentBorder};
  padding: 8px 16px;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
`;

export const Label = styled.label`
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.regular};
  margin-right: 17px;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.colors.secondary.gray300};
`;

export const Select = styled.select`
  border: 0;
  outline: 0;
  cursor: pointer;
`;
